import * as Yup from "yup";

export type nl3LiveclassMaster = {
  admissionNumber: string;
  nlearn3LiveclassPackageIds: string;
  markAsDeleted: string;
};

export const nl3LiveclassMasterInitialValues = {
  admissionNumber: "",
  nlearn3LiveclassPackageIds: "",
  markAsDeleted: ""
};

export const nl3LiveclassMasterMandatoryFields = [];

export const nl3LiveclassMasterValidationSchema = Yup.object().shape({
  
});

export const nl3LiveclassMasterProperties = [
  {
    id: "admissionNumber",
    type: "text",
    label: "Admission Number",
    Placeholder: "Enter Admission Number", 
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "nlearn3LiveclassPackageIds",
    type: "multi-select-dependency",
    label: "Nl3 Liveclass Package *",
    list: "nl3_liveclass_packages_gq",
    keyValue: { label: "nameWithCount", value: "id" },
    fieldKeyLists: {},
    options: [],
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "markAsDeleted",
    type: "normal-select",
    label: "Mark As Deleted",
    options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
    ],
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
